// extracted by mini-css-extract-plugin
export default {"nav":"Pagination_nav__XQzvS","page":"Pagination_page__SD5GN","active":"Pagination_active__sE9gT","ellipsis":"Pagination_ellipsis__uac0-"};